import { render, staticRenderFns } from "./NoActiveVje.vue?vue&type=template&id=770608da&"
import script from "./NoActiveVje.vue?vue&type=script&lang=js&"
export * from "./NoActiveVje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports